import React from "react";
import { render } from "storyblok-rich-text-react-renderer";
import Link from "next/link";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GlossaryItem = props => {
  var {
    title,
    description
  } = props;
  return /*#__PURE__*/_jsxs("article", {
    className: "prose text-foreground prose-headings:text-foreground prose-a:text-foreground prose-strong:text-foreground prose-em:text-foreground",
    children: [/*#__PURE__*/_jsx("h1", {
      children: title
    }), /*#__PURE__*/_jsx("p", {
      children: render(description)
    }), /*#__PURE__*/_jsx(Link, {
      href: "/glossary/",
      children: "\xAB Back to Glossary Index"
    })]
  });
};
//# sourceMappingURL=glossary_item.js.map